import api from '@/api'

export default {
  getAuthorById(context, payload) {
    return api.account
      .getById(payload.organizationId, payload.authorId)
      .then(({ data: account }) => {
        return `${account?.displayname ?? ''} ${account?.familyname ??
          ''}`.trim()
      })
  },

  async setValidation(
    context,
    {
      revId,
      validationType,
      isValidated,
      organizationId,
      revType,
      validationId,
    }
  ) {
    const endpoint = isValidated ? 'addValidation' : 'removeValidation'

    await api[revType][endpoint]({
      organizationId,
      revId,
      validationType,
      isValidated,
      validationId,
    })
  },

  async setImplementationValidation(
    context,
    { organizationId, revId, revType, validationId, isValidated }
  ) {
    const endpoint = isValidated
      ? 'removeImplementationValidation'
      : 'addImplementValidation'

    return await api[revType][endpoint]({
      organizationId,
      revId,
      validationId,
    })
  },

  async setImpactValidation(
    context,
    { organizationId, revId, revType, validationId, isValidated }
  ) {
    const endpoint = isValidated
      ? 'removeImpactValidation'
      : 'addImpactValidation'

    return await api[revType][endpoint]({
      organizationId,
      revId,
      validationId,
    })
  },

  async setHighlight(
    context,
    { revId, isHighlighted, organizationId, revType }
  ) {
    const endpoint = isHighlighted ? 'addHighlight' : 'removeHighlight'
    await api[revType][endpoint]({
      organizationId,
      revId,
    })
  },
}
